import React, { useState, useEffect } from "react";
import styles from "../HowItWorks/HowItWorks.module.css";
import Modal from "../Modal/Modal";
import FreeAccount from "../FreeAccount/FreeAccount";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { sendEmail, verifyEmailOtp } from "../../../lib/Store";
import { PortableText } from "@portabletext/react";
import useUTMParams from "../../../hook/useUTMParams" 
import useUserDeviceInfo from "../../../hook/useUserDeviceInfo";
import { useRef } from "react";
const HowItWorks = ({ howitworks }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [email, setEmail] = useState(sessionStorage.getItem("email") || "");
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [resendTimer, setResendTimer] = useState(0);
  const [resendEndTime, setResendEndTime] = useState(null);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [isOtp, setIsOtp] = useState(false);
  const inputRefs = useRef([]);
  const utm_data= useUTMParams();
  const environmentInfo=useUserDeviceInfo();

  useEffect(() => {
    if (!resendEndTime) return;

    const interval = setInterval(() => {
      const timeLeft = Math.max(
        0,
        Math.floor((resendEndTime - Date.now()) / 1000)
      );
      setResendTimer(timeLeft);

      if (timeLeft <= 0) {
        setIsResendDisabled(false);
        setResendEndTime(null);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [resendEndTime]);
  if (!howitworks) return null;
  const {
    sectionLabel,
    headlinePrefix,
    headlineHighlight,
    headlineSuffix,
    steps = [],
    ctaCard,
  } = howitworks;

  const handleCreateAccount = async () => {
    setErrMsg("");
    const trimmed = email.trim();
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);

    if (!isValidEmail) {
      setErrMsg("Please enter a valid email address.");
      return;
    }
    sessionStorage.setItem("email", email);

    try {
      setLoading(true);
      const res = await sendEmail(trimmed, utm_data ? utm_data : null,environmentInfo);

      setIsOtp(true);
      setIsResendDisabled(true);
      //  Success: OTP sent successfully
      if (res?.status === 200 && res?.data?.status !== 409) {
        // window.open(
        //   `${process.env.REACT_APP_NAVIGATION_LOGIN}/signup?otp-not-required&email=${trimmed}`,
        //   "_blank"
        // );
        // return;
        const endTime = Date.now() + 300 * 1000;
        setResendEndTime(endTime);
        setIsResendDisabled(true);
      } else {
        const message =
          res?.error ||
          res?.response?.data?.error ||
          "OTP already sent. Please check your email.";

        setErrMsg(message);
        setErrMsg(message);

        // Wait 2s before redirecting
        // setTimeout(() => {
        //   window.open(
        //     `${process.env.REACT_APP_NAVIGATION_LOGIN}/signup?otp-not-required&email=${trimmed}`,
        //     "_blank"
        //   );
        // }, 2000);

        return;
      }
    } catch (e) {
      console.error("sendEmail failed:", e);
      console.log("handle");
      //  Handle 409 (OTP already sent or user exists)
      if (e?.response?.status === 409) {
        console.log("handle");
        const message =
          e?.response?.data?.error ||
          "OTP already sent. Please check your email.";

        setErrMsg(message);

        // // Wait 2s before redirecting
        // setTimeout(() => {
        //   window.open(
        //     `${process.env.REACT_APP_NAVIGATION_LOGIN}/signup?otp-not-required&email=${trimmed}`,
        //     "_blank"
        //   );
        // }, 2000);

        return;
      }

      //  Handle all other errors
      const errorMessage =
        e?.response?.data?.error ||
        e?.response?.data?.message ||
        e?.message ||
        "Something went wrong. Please try again.";
      setErrMsg(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
    } catch (error) {}
    let res = await verifyEmailOtp(email, otp);
    console.log({ res });

    if (res?.token) {
      setIsOtp(false);
      setEmail("");
      setOtp(new Array(6).fill(""));
      sessionStorage.removeItem("email");

      window.open(
        `${process.env.REACT_APP_NAVIGATION_LOGIN}/?token=${res.token}&verifiedDetails=${res.user?.verifyDetails}`,
        "_blank"
      );
    }
    if (res?.response?.data?.error) {
      setErrMsg(res?.response?.data?.error);
      console.log(res?.response?.data?.error);
    }

    setLoading(false);
  };

  const ptComponents = {
    marks: {
      purple: ({ children }) => (
        <span className="text-purple-500 font-semibold">{children}</span>
      ),
      break: ({ children }) => (
        <>
          <br />
          {children}
        </>
      ),
    },
  };

  const handleOtpChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };
  // const finalOtp = otp.join("");

  // const isOtpComplete = otp.join("").length === 6;
  return (
    <>
      {" "}
      <div className={styles.containerBox}>
        <div className={styles.container}>
          <div className={styles.TopBar}>
            <div className={styles.Title}>
              <h1 className={styles.strokeText}>{sectionLabel}</h1>
              <div className={styles.Strip}></div>
            </div>

            <div className={styles.SubtitleDiv}>
              <h3 className={styles.subtitle}>
                {headlinePrefix}{" "}
                <span className="spanText ">{headlineHighlight}</span>{" "}
                {headlineSuffix}
              </h3>
            </div>
          </div>

          <div className={styles.timelineWrapper}>
            <div className={styles.timelineContainer}>
              {steps.map((s, idx) => (
                <div className={styles.step} key={idx}>
                  <div className={styles.leftIcon}>
                    {/* icon from Sanity, fallback to your old SVG if missing */}
                    {s?.icon?.src ? (
                      <img
                        src={s.icon.src}
                        alt={s?.icon?.alt || s.title || "icon"}
                      />
                    ) : (
                      <img
                        src={
                          idx === 0
                            ? "Svg/Sign-up.svg"
                            : idx === 1
                            ? "Svg/Customize.svg"
                            : "Svg/Go-live.svg"
                        }
                        alt="step-icon"
                      />
                    )}
                  </div>

                  <div className={styles.icon}>{idx + 1}</div>

                  <div className={styles.content}>
                    <h3>{s.title}</h3>

                    {Array.isArray(s.description) &&
                    s.description.length > 0 ? (
                      <PortableText
                        value={s.description}
                        components={ptComponents}
                      />
                    ) : (
                      s.descriptionPlain && <p>{s.descriptionPlain}</p>
                    )}

                    {/* CTA button only on the last step (as in your static design).
                        Move/duplicate if you want it elsewhere */}
                    {idx === steps.length - 1 && (
                      <div
                        className={styles.cerateBtn}
                        onClick={() => setIsModalOpen(true)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ")
                            setIsModalOpen(true);
                        }}
                      >
                        <img src="Svg/btn-shape.svg" alt="btn-shape" />
                        <p>
                          {ctaCard?.ctaLabel?.length ? (
                            <PortableText
                              value={ctaCard.ctaLabel}
                              components={ptComponents}
                            />
                          ) : (
                            ctaCard?.ctaLabelPlain || "Create my FREE account"
                          )}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className={styles.PhoneContainer}>
              <div className={styles.phoneFrame}>
                <div className={styles.card}>
                  {/* Logo */}
                  <div className={styles.logo}>
                    {ctaCard?.logo?.src ? (
                      <img
                        src={ctaCard.logo.src}
                        alt={ctaCard.logo.alt || "logo"}
                      />
                    ) : (
                      <img src="Svg/rexpt-logo.svg" alt="rexpt-logo" />
                    )}
                  </div>

                  <hr className={styles.divider} />

                  {/* Heading */}

                  {!isOtp ? (
                    <>
                      <h2 className={styles.heading}>
                        {Array.isArray(ctaCard?.title) &&
                        ctaCard.title.length > 0 ? (
                          <PortableText
                            value={ctaCard.title}
                            components={ptComponents}
                          />
                        ) : (
                          ctaCard?.titlePlain && (
                            <>
                              {ctaCard.titlePlain.split("\n").map((line, i) => (
                                <h2 key={i}>
                                  {line}
                                  {i !==
                                    ctaCard.titlePlain.split("\n").length -
                                      1 && <br />}
                                </h2>
                              ))}
                            </>
                          )
                        )}
                      </h2>

                      <p className={styles.subText}>
                        {Array.isArray(ctaCard?.subtext) &&
                        ctaCard.subtext.length > 0 ? (
                          <PortableText
                            value={ctaCard.subtext}
                            components={ptComponents}
                          />
                        ) : (
                          ctaCard?.subtextPlain && <p>{ctaCard.subtextPlain}</p>
                        )}
                      </p>
                      <div className={styles.InputDiv}>
                        <input
                          type="email"
                          placeholder={
                            ctaCard?.emailPlaceholder || "johnwick@gmail.com"
                          }
                          className={`${styles.input} ${
                            errMsg ? styles.inputError : ""
                          }`}
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                         onKeyDown={(e) => {
      if (e.key === " ") e.preventDefault(); // ⛔ block pressing space
      if (!loading && e.key === "Enter") handleCreateAccount();
    }}
                          disabled={loading}
                          aria-invalid={!!errMsg}
                          aria-describedby={errMsg ? "email-error" : undefined}
                        />
                        {/* Error */}
                        {errMsg ? (
                          <p
                            id="email-error"
                            className={styles.errorText}
                            role="alert"
                          >
                            {errMsg}
                          </p>
                        ) : null}
                      </div>

                      <div
                        className={styles.btn}
                        role="button"
                        tabIndex={0}
                        onClick={loading ? undefined : handleCreateAccount}
                        onKeyDown={(e) => {
                          if (!loading && (e.key === "Enter" || e.key === " "))
                            handleCreateAccount();
                        }}
                        aria-busy={loading}
                        aria-disabled={loading}
                      >
                        <img src="Svg/btn-shape.svg" alt="btn-shape" />
                        <p>
                          {loading ? (
                            "Processing…"
                          ) : Array.isArray(ctaCard?.ctaLabel) &&
                            ctaCard.ctaLabel.length > 0 ? (
                            <PortableText
                              value={ctaCard.ctaLabel}
                              components={ptComponents}
                            />
                          ) : (
                            ctaCard?.ctaLabelPlain || (
                              <>
                                Create my <b>FREE</b> account
                              </>
                            )
                          )}
                        </p>
                      </div>
                    </>
                  ) : (
                    <>
                      {email && (
                        <p className={styles.codeText}>
                          Email has been sent to <strong>{email}</strong>
                        </p>
                      )}
                      <p className={styles.codeText}>
                        Enter the code sent to your email
                      </p>

                      <div className={styles.otpContainer}>
                        {[...Array(6)].map((_, i) => (
                          <input
                            key={i}
                            id={`otp-${i}`}
                            maxLength="1"
                            value={otp[i] || ""} // ✅ FIXED — use otp[i]
                            onChange={(e) => handleOtpChange(e.target.value, i)}
                            className={styles.otpInput}
                            onKeyDown={(e) => handleKeyDown(e, i)}
                            ref={(el) => (inputRefs.current[i] = el)}
                            onInput={(e) => {
                              const target = e.target;
                              target.value = target.value.replace(
                                /[^0-9]/g,
                                ""
                              );
                            }}
                            inputMode="numeric"
                            type="tel"
                          />
                        ))}
                      </div>

                      <p className={styles.SpamMessage}>
                        Please check your spam folder if you don’t find it in
                        your main inbox.
                      </p>
                      <div className={styles.resendContainer}>
                        <button
                          type="button"
                          className={styles.resendButton}
                          onClick={handleCreateAccount}
                          disabled={isResendDisabled}
                          style={{
                            cursor: isResendDisabled
                              ? "not-allowed"
                              : "pointer",
                            opacity: isResendDisabled ? 0.5 : 1,
                            background: "none",
                            border: "none",
                            color: "#6524EB",
                            fontWeight: "bold",
                            fontSize: "14px",
                          }}
                        >
                          {isResendDisabled && resendTimer > 0
                            ? `Resend One Time Password in ${String(
                                Math.floor(resendTimer / 60)
                              ).padStart(2, "0")}:${String(
                                resendTimer % 60
                              ).padStart(2, "0")}`
                            : "Resend One Time Password"}
                        </button>
                      </div>

                      {errMsg && (
                        <p
                          className={styles.OTPalreadySent}
                          style={{
                            color: "red",
                            marginTop: "10px",
                            fontWeight: "500",
                          }}
                        >
                          {errMsg}
                        </p>
                      )}

                      <div className={styles.Btn}>
                        <div type="submit">
                          <div className={styles.btnTheme}>
                            <div
                              className={styles.btn}
                              role="button"
                              tabIndex={0}
                              // Disable click when loading OR OTP not complete
                              onClick={
                                !loading && otp?.join("").length === 6
                                  ? handleSubmit
                                  : undefined
                              }
                              onKeyDown={(e) => {
                                if (
                                  !loading &&
                                  otp.join("").length === 6 &&
                                  (e.key === "Enter" || e.key === " ")
                                ) {
                                  handleSubmit();
                                }
                              }}
                              aria-busy={loading}
                              aria-disabled={
                                loading || otp.join("").length !== 6
                              }
                              style={{
                                opacity: otp.join("").length === 6 ? 1 : 0.6,
                                pointerEvents:
                                  otp.join("").length === 6 ? "auto" : "none",
                                transition: "opacity 0.3s ease",
                              }}
                            >
                              <img src="Svg/btn-shape.svg" alt="btn-shape" />
                              <p>
                                {loading ? (
                                  "Processing…"
                                ) : (
                                  <>
                                    Verify <b>OTP</b>
                                  </>
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      
                    </>
                  )}

                  <p className={styles.login}>No Credit Card Needed</p>

                  <p className={styles.footer}>
                    No credit card required • Cancel anytime <br />
                    By signing up you agree to our{" "}
                    <a href="https://www.rxpt.us/Terms-Condition" target="_blank">Terms & Privacy</a>
                  </p>
                </div>
                <div className={styles.ellipsDiv}>
                  <div className={styles.elips1}>
                    <img src="Svg/Ellipse-yellow.svg" alt="Ellipse-blue" />
                  </div>
                  <div className={styles.elips2}>
                    <img src="Svg/Ellipse-blue.svg" alt="Ellipse-blue" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.arrow}>
            <DotLottieReact
              src="https://lottie.host/873ef697-740b-42b9-afe8-461f833d05ca/pLzxIgFHR0.lottie"
              loop
              autoplay
            />
            {/* <img src="Svg/arrow.gif" alt="arrowGif" /> */}
          </div>
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        bgColor="transparent"
        boxShadow="unset"
        closeColor="#fff"
        maxWidth="500px"
      >
        <FreeAccount closeModal={() =>  setIsModalOpen(false)}  coming="1"/>
      </Modal>
    </>
  );
};

export default HowItWorks;
